import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function PayrollDateSortToggle({
    value,
    onChange,
    'aria-label': ariaLabel = 'Payroll Date Sort Direction',
}) {
    return (
        <ToggleButtonGroup
            size="small"
            color="primary"
            value={value}
            exclusive
            onChange={(_, nextValue) => {
                if (nextValue) onChange(nextValue);
            }}
            aria-label={ariaLabel}
        >
            <ToggleButton
                value="desc"
                aria-label="Newest first"
                title="Newest first"
                sx={{ width: '24px', height: '24px' }}
            >
                <ArrowDropDownIcon />
            </ToggleButton>
            <ToggleButton
                value="asc"
                aria-label="Oldest first"
                title="Oldest first"
                sx={{ width: '24px', height: '24px' }}
            >
                <ArrowDropDownIcon sx={{ transform: 'rotate(180deg)' }} />
            </ToggleButton>
        </ToggleButtonGroup>
    );
}

export default PayrollDateSortToggle;
